import { RootState } from "../../store";

export const selectDocument = (state: RootState) => state.document;